import { render, staticRenderFns } from "./WithdrawWalletModal.vue?vue&type=template&id=5af80026&scoped=true&"
import script from "./WithdrawWalletModal.vue?vue&type=script&lang=js&"
export * from "./WithdrawWalletModal.vue?vue&type=script&lang=js&"
import style0 from "./WithdrawWalletModal.vue?vue&type=style&index=0&id=5af80026&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af80026",
  null
  
)

export default component.exports